import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/**
 * A very VM friendly rgba datastructure.
 * Please don't touch unless you take a look at the IR.
 */
export var RGBA8 = /*#__PURE__*/function () {
  function RGBA8(r, g, b, a) {
    _classCallCheck(this, RGBA8);

    this.r = RGBA8._clamp(r);
    this.g = RGBA8._clamp(g);
    this.b = RGBA8._clamp(b);
    this.a = RGBA8._clamp(a);
  }

  _createClass(RGBA8, [{
    key: "equals",
    value: function equals(other) {
      return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
  }], [{
    key: "_clamp",
    value: function _clamp(c) {
      if (c < 0) {
        return 0;
      }

      if (c > 255) {
        return 255;
      }

      return c | 0;
    }
  }]);

  return RGBA8;
}();
RGBA8.Empty = new RGBA8(0, 0, 0, 0);